module.exports = __webpack_public_path__ + "img/dotPeek_icon.9d4048af.png";